import { type ParseResult, parseJsonEventStream } from "@ai-sdk/provider-utils";
import { readUIMessageStream, type UIMessage, uiMessageChunkSchema } from "ai";

export async function* readAssistantMessageStream(options: {
  response: Response;
  lastMessage?: UIMessage;
}): AsyncGenerator<UIMessage, void, void> {
  const { response, lastMessage } = options;

  if (!response.ok) {
    const errorText = await response.text().catch(() => "request failed");
    throw new Error(errorText || `request failed (${response.status})`);
  }

  if (!response.body) {
    throw new Error("stream response body missing");
  }

  const stream = parseJsonEventStream({
    stream: response.body,
    schema: uiMessageChunkSchema as never,
  }).pipeThrough(
    new TransformStream<ParseResult<unknown>, unknown>({
      transform(chunk, controller) {
        if (!chunk.success) {
          throw chunk.error;
        }

        controller.enqueue(chunk.value);
      },
    }),
  );

  for await (const message of readUIMessageStream({
    message: lastMessage,
    stream: stream as ReadableStream<never>,
    terminateOnError: true,
  })) {
    yield message;
  }
}
